import React from 'react';
import {
  Logout,
  StaticWebAuthLogins,
  UserInfoContextProvider,
  UserPurge,
  useUserInfo,
} from "@aaronpowell/react-static-web-apps-auth";

const UserDisplay = () => {
  const { clientPrincipal, loaded } = useUserInfo();

  if (!loaded) {
    return <p>Checking user info...</p>;
  }

  if (clientPrincipal) {
    return (
      <div>
        <p>
          {clientPrincipal.identityProvider} {clientPrincipal.userDetails}{" "}
          {clientPrincipal.userId} {clientPrincipal.userRoles}
        </p>
        <p>
          <Logout />
        </p>
        <p>
          <UserPurge provider={clientPrincipal.identityProvider} />
        </p>
      </div>
    );
  }

  return <p>User not signed in</p>;
};


function App() {
  return (
    <div className="App">
      <header className="App-header">
        
        <p>
          Edit <code>src/App.tsx</code> and save to reload. Then see if it is working.....
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
        <StaticWebAuthLogins
          customProviders={[{ id: "okta", name: "okta" }]}
          label={(name) => `Do sign in ${name}`}
        />

        <UserInfoContextProvider>
          <UserDisplay />
        </UserInfoContextProvider>
      </header>
    </div>
  );
}

export default App;
